import {transliterateText} from "./utils";
import {editableTextContent} from "./contentEditableText";

/**
 * Build the download filename for a multi-file export archive.
 *
 * Titled exports become `<product>-<slug>_<timestamp>.zip`: the title is
 * lowercased, transliterated to Latin, whitespace runs become single
 * hyphens, and everything outside [A-Za-z0-9_-] is stripped. When the slug
 * comes out empty — no title, whitespace-only, all punctuation, or a script
 * transliteration doesn't cover — the filename falls back to
 * `<product>-<channel>_<timestamp>.zip` so the download always has a
 * readable name.
 */
export function buildArchiveFilename(
  product: string,
  channel: string,
  title: unknown,
  timestamp: number
): string {
  let base = `${product}-${channel}`;

  const text = typeof title === "string" ? editableTextContent(title).trim() : "";
  if (text !== "") {
    const slug = transliterateText(text.toLowerCase())
      .replace(/\s+/g, "-")
      .replace(/[^\w-]/g, "")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
    if (slug !== "") {
      base = `${product}-${slug}`;
    }
  }

  return `${base}_${timestamp}.zip`;
}
